import images from "@assets/images";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectForgotData } from "@src/ducks/slices/forgot.slice";
import React from "react";
import { ImageBackground } from "react-native";
import CheckEmail from "./CheckEmail";
import EnterEmail from "./EnterEmail";
import useStyles from "./styles.css";

const Forgot = () => {
  const styles = useStyles();
  const forgot =  useAppSelector(selectForgotData);

  return (
    <ImageBackground
      source={{uri: images["gamezone-bg"]}}
      style={[styles.container]}
      resizeMode="stretch"
    >
      {forgot.email ? <CheckEmail email={forgot.email} /> : <EnterEmail />}
    </ImageBackground>
  );
};

export default Forgot;
